import {
  PROSPECT_ACTION_FILTER_ALL,
  ProspectActionFilter,
  ProspectActionFilterMode,
} from "@/app/types/prospect/ProspectActionFilter";
import { ProspectListTab } from "@/app/types/prospect/ProspectListTab";
import { LocalStorageKey } from "@/app/vars/Storage";

export class UProspectFilter {
  public static readStoredTab(): ProspectListTab {
    if (typeof window === "undefined") {
      return ProspectListTab.ALL;
    }

    const stored = localStorage.getItem(LocalStorageKey.PROSPECT_LIST_TAB);

    return stored && Object.values(ProspectListTab).includes(stored as ProspectListTab)
      ? (stored as ProspectListTab)
      : ProspectListTab.ALL;
  }

  public static readStoredActionFilter(): ProspectActionFilter {
    if (typeof window === "undefined") {
      return PROSPECT_ACTION_FILTER_ALL;
    }

    try {
      const stored = localStorage.getItem(LocalStorageKey.PROSPECT_LIST_ACTION_FILTER);
      const parsed = stored ? (JSON.parse(stored) as ProspectActionFilter) : null;

      if (!parsed || !Object.values(ProspectActionFilterMode).includes(parsed.mode)) {
        return PROSPECT_ACTION_FILTER_ALL;
      }

      return { mode: parsed.mode, kind: parsed.kind, typeId: parsed.typeId };
    } catch (_error) {
      return PROSPECT_ACTION_FILTER_ALL;
    }
  }

  public static storeTab(tab: ProspectListTab): void {
    if (typeof window === "undefined") {
      return;
    }

    localStorage.setItem(LocalStorageKey.PROSPECT_LIST_TAB, tab);
  }

  public static storeActionFilter(filter: ProspectActionFilter): void {
    if (typeof window === "undefined") {
      return;
    }

    localStorage.setItem(LocalStorageKey.PROSPECT_LIST_ACTION_FILTER, JSON.stringify(filter));
  }
}
